import { InfoMessagePositionsEnum, InfoMessage } from '@websky/graphql';

export const filterMessageByPosition = (
	slotPosition: InfoMessagePositionsEnum | InfoMessagePositionsEnum[],
	message: InfoMessage
) => {
	if (Array.isArray(slotPosition)) {
		return (
			(slotPosition.includes(InfoMessagePositionsEnum.default) && !message.positions?.length) ||
			slotPosition.some(position => message.positions?.includes(position))
		);
	}

	return (
		(slotPosition === InfoMessagePositionsEnum.default && !message.positions?.length) ||
		message.positions?.includes(slotPosition)
	);
};
